






import { defineComponent, ref } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import VaultController from "@/components/VaultController";

export default defineComponent({
  name: "PageVault",
  components: { BasePage, VaultController },
  setup() {
    const loading = ref(false);
    return { loading };
  },
});
